import { Hourglass } from '@phosphor-icons/react';
import { Card } from '@/components/ui';

export function ComingSoonPage({ title }: { title: string }) {
  return (
    <div className="mx-auto max-w-[900px]">
      <h1 className="mb-2 font-display text-3xl font-semibold tracking-tight">{title}</h1>
      <p className="mb-10 font-editorial text-lg italic text-ink-muted">
        We're polishing this surface. Back soon.
      </p>
      <Card className="flex flex-col items-center justify-center gap-3 px-6 py-20 text-center">
        <span className="grid h-12 w-12 place-items-center rounded-full bg-rail">
          <Hourglass size={22} />
        </span>
        <p className="text-sm text-ink-muted">This section is on the roadmap.</p>
      </Card>
    </div>
  );
}
